export default __webpack_public_path__ + "static/media/mk.4b7324f3.png";